<template>
  <LayoutMinimal>
    <div
            id="signed_out"
    >
      <div class="image">
      </div>
      <h1>
        {{$t('signed_out.title')}}
      </h1>
      <h2>
        {{$t('signed_out.subtitle')}}
      </h2>
      <p>
        {{$t('signed_out.message')}}
      </p>
      <router-link class="btn" :to="{name: 'home'}">
        {{$t('signed_out.buttons.home')}}
      </router-link>
    </div>
  </LayoutMinimal>
</template>

<script>
  import LayoutMinimal from "../layouts/LayoutMinimal";

  export default {
    components: {
      LayoutMinimal,
    },
    mounted(){
      if(this.$auth.ready() && this.$auth.check()){
          this.$auth.logout();
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../styles/variables';
  @import '../styles/classes';

  #signed_out{
    padding: 2em 1em;
    text-align: center;

    .image{
      display: block;
      margin: auto;
      height: 300px;
      background-image: url('/img/subscribe_girl.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    .btn{
      @extend %fresh-btn;
    }
  }
</style>
